import dynamic from 'next/dynamic';
import { NRPListProps } from './NRPList.types';

export const NRPList = dynamic<NRPListProps>(() => import('./NRPList').then(module => module.NRPList));
